import { Component, Vue, Prop, Watch, Ref } from 'vue-property-decorator'
import '../index.less'
import {
  ProductionOrderServiceProxy,
  ProductionPlan,
  ProductionOrderOutDTO,
  OrderProcessOutDTO,
  CraftCardBO,
  ProductionOrderProcessServiceProxy,
  OrderProcessReportWorkDTO,
  ProductionOrderProcessWorkStationRecordServiceProxy,
  OrderProcessItemQcServiceProxy,
  ProductionOrderProcessAssignRecordServiceProxy,
} from '@/service-proxies/app-v2/coproduction.service-proxies'
import { TenantBizFieldServiceProxy, AuthorityDomainServiceProxy, FieldSettingServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { isDisplayShow, convertSeconds } from '@/utils/index'
import DistributePlan from './DistributePlan.vue'
import StationCapacity from './stationCapacity.vue'
import RecordButton from './RecordButton.vue'
import WipWarehousing from './WipWarehousing.vue'
import WipDelivery from './WipDelivery.vue'
import ScrapTable from './ScrapTable.vue'
import PointModal from './PointModal.vue'
import dayjs from 'dayjs'
import { statusListColor, statusList } from '@/utils/commonDef'
import { WorkStationWorkingConditionParamSettingServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'

const posp = new ProductionOrderServiceProxy()
const popsp = new ProductionOrderProcessServiceProxy()
const esp = new EmployeeServiceProxy()
const wasp = new WarehouseAreaServiceProxy()
const tenantBizFieldServiceProxy = new TenantBizFieldServiceProxy()
const adsp = new AuthorityDomainServiceProxy()
const msp = new MaterialServiceProxy()
const popwsrsp = new ProductionOrderProcessWorkStationRecordServiceProxy()
const opiqcsp = new OrderProcessItemQcServiceProxy()
const stsp = new ScrappedTypeServiceProxy()
const productionOrderProcessAssignRecordServiceProxy = new ProductionOrderProcessAssignRecordServiceProxy()
const workStationWorkingConditionParamSettingServiceProxy = new WorkStationWorkingConditionParamSettingServiceProxy()
const fssp = new FieldSettingServiceProxy()

import html2canvas from 'html2canvas'
import jspdf from 'jspdf'
import { EmployeeServiceProxy, EmployeeInfoBO, EmployeeSearchDTO } from '@/service-proxies/app-v2/employee.service-proxies'
import ExportDropdown from './ExportDropdown.vue'
import { exportWorkOrder } from '@/api/api'
import { WarehouseAreaServiceProxy } from '@/service-proxies/app-v2/warehouse.service-proxies'
import { MaterialServiceProxy } from '@/service-proxies/app-v2/material.service-proxies'
import QualityTesting from './QualityTesting.vue'
import { ScrappedTypeServiceProxy } from '@/service-proxies/app-v2/qc.service-proxies'
import { mapActions } from 'vuex'
import router from '@/router'

const isNull = val => {
  return typeof val === 'object' && !val
}

@Component({
})
class WorkTable extends Vue {
  @Prop({ default: () => [{ order: 1 }] }) readonly data: ProductionOrderOutDTO[]
  @Prop({ default: false }) readonly loading: boolean
  @Prop({ default: () => ({}) }) currentData: ProductionOrderOutDTO
  @Prop({ default: 0 }) currentIndex: number
  @Prop({ default: 120 }) scrollY: number
  @Prop({ default: "" }) selectedKey: String

  created() {
    this.getTableColumn()
  }

  get planTypeId() {
    const chars = this.$route.path.split('/')
    return chars[chars.length - 1]
  }
  productColums = []
  showColumns = []
  async getTableColumn() {
    this.productColums = []
    this.productColums = await tenantBizFieldServiceProxy.getTenantBizField('plan_order', this.planTypeId)
    this.handleColumns()
  }
  handleColumns() {
    this.showColumns = []
    if (!this.productColums || !this.productColums.length) {
      return
    }
    // 字段排序
    this.productColums.sort((a, b) => {
      return a.sort - b.sort
    })
    // 字段显隐
    let columns = []
    this.productColums.map((item, index) => {
      if (isDisplayShow(item.isDisplay, 2)) {
        // 自定义字段：产品类型
        const temp: any = {
          title: item.title,
          key: item.code,
          dataIndex: item.code,
          ellipsis: true,
        }
        if (index + 1 !== this.productColums.length) {
          temp.width = (temp.title.length + 1) * 20
        }
        if(temp.key === 'orderStatus'){
          temp.width= 90
          temp.customRender = (text) => {
            return (<a-tag color={statusListColor[text]}>{ this.$t(statusList[text]) }</a-tag>)
          }
        }
        columns.push(temp)
      }
    })
    this.showColumns = [...columns]
  }

  select(keys, rows) {
    this.$emit('change', { index: keys[0], data: rows[0] })
  }

  clickRow(record, index) {
    this.$emit('change', { index: index, data: record })
  }


  render() {
    return (
      <ml-table
        size="small"
        bordered={true}
        columns={this.showColumns}
        dataSource={this.data}
        loading={this.loading}
        pagination={false}
        selectRowKey={this.selectedKey}
        rowKey="id"
        style={{ marginBottom: '16px' }}
        customRow={(record, index) => ({
          on: {
            click: () => {
              this.clickRow(record, index)
            },
          },
        })}
        // rowSelection={{ type: 'radio', selectedRowKeys: this.selectedKeys, onChange: this.select }}
        canFixedHead={true}
        canChangeColWidth={true}
        scroll={{ x:960 ,y: this.scrollY }}
      >
      </ml-table>
      // <div>1</div>
    )
  }
}

@Component({
  components: {
    WipWarehousing,
    WipDelivery,
    QualityTesting
  },
  methods: {
    ...mapActions({
      generateRoutes: 'permission/generateRoutes'
    })
  }
})
class ProcessTable extends Vue {
  @Prop({ default: () => [{ order: 1 }] }) readonly data: OrderProcessOutDTO[]
  @Prop({ default: false }) readonly loading: boolean
  @Prop({ default: () => ({}) }) currentData: OrderProcessOutDTO
  @Prop({ default: 0 }) currentIndex: number
  @Prop({ default: () => ({}) }) readonly currentWork: any
  @Prop({ default: () => null }) readonly plan: ProductionPlan
  @Prop({ default: "" }) selectedKey: string
  @Prop({ default: 120 }) scrollY: number

  created() {
    this.getTableColumn()
  }
  generateRoutes
  productColums = []
  showColumns = []
  WIPwarehousingVisible = false
  WIPdeliveryVisible = false
  listWare = [] // 库区列表
  employeesList = [] // 人员列表
  treeList = [] // 职权域列表
  materialList = [] // 物料列表
  qualityTestingVisible = false // 质检
  qualityPerson = [] //质检人员
  porcessItem = {} // 工单工序详情
  get selectedKeys() {
    return [this.currentIndex]
  }
  get planTypeId() {
    const chars = this.$route.path.split('/')
    return chars[chars.length - 1]
  }
  async getTableColumn() {
    this.productColums = []
    this.productColums = await tenantBizFieldServiceProxy.getTenantBizField('order_process', this.planTypeId)
    this.handleColumns()
  }
  handleColumns() {
    this.showColumns = []
    if (!this.productColums || !this.productColums.length) {
      return
    }
    // 字段排序
    this.productColums.sort((a, b) => {
      return a.sort - b.sort
    })
    // 字段显隐
    let columns = []
    this.productColums.map((item, index) => {
      if (isDisplayShow(item.isDisplay, 2)) {
        // 自定义字段：产品类型
        const temp: any = {
          title: item.title,
          key: item.code,
          dataIndex: item.code,
          ellipsis: true,
        }
        if (index + 1 !== this.productColums.length) {
          temp.width = (temp.title.length + 1) * 20
        }
        if(temp.key === 'processStatus'){
          temp.width = 80
          temp.customRender = (text) => {
            return (<a-tag color={statusListColor[text]}>{ this.$t(statusList[text]) }</a-tag>)
          }
        }
        if (['prepareTime', 'disassemblyTime', 'transportTime'].includes(temp.key)) {
          temp.customRender = val => val / 60
        }
        columns.push(temp)
      }
    })
    this.showColumns = [...columns]
  }

  select(keys, rows) {
    this.$emit('change', { index: keys[0], data: rows[0] })
  }

  clickRow(record, index) {
    this.$emit('change', { index: index, data: record })
  }
  WIPwarehousing(){
    this.WIPwarehousingVisible = true
  }
  WIPdelivery(){
    this.WIPdeliveryVisible = true
  }
  mounted(){
    wasp.listWarehouseArea('').then(res =>{
      this.listWare = res
    })
    esp.getPageEmployees(1,{statusList: [1]} as EmployeeSearchDTO,"",999999).then(res =>{
      this.employeesList = res.records
    })
    adsp.treeList().then(res =>{
      const arr:any = res.data
      arr.forEach(item => {
        this.treeList.push(this.filterData(item))
      })
    })
    msp.getMaterialList(2,"",2,"").then(res =>{
      this.materialList = res
    })
  }

  filterData(item: any) {
    const arr = {
      title: item.title,
      value: item.id,
      key: item.id,
      children: [],
    }
    if (item.children && item.children.length > 0) {
      item.children.forEach(res =>{
        arr.children.push(this.filterData(res))
      })
    } else {
      delete item.children;
    }
    return arr;
  }

  reloadWip(){
    this.WIPwarehousingVisible = false
    this.WIPdeliveryVisible = false
    this.$emit('reloadWip')
  }

  qualityTesting(){
    opiqcsp.judge(this.selectedKey).then(res =>{
      switch (res) {
        case 1:
          this.openQualityTesting()
          break;
        case 2:
          this.$confirm({
            title: `${this.$t('tips')}?`,
            content: `${this.$t('page_job_plan_path_to_maintain')}!`,
            okText: `${this.$t('page_job_plan_maintain')}`,
            onOk: () => {
              return new Promise<void>((resolve, reject) => {
                this.getrout()
                resolve()
              })
            },
            onCancel() {},
          });
          break;
        case 3:
          this.$warning({
            title: `${this.$t('tips')}?`,
            content: `${this.$t('page_job_plan_cont_quality_testing')}!`,
            okText: `${this.$t('ok')}`
          });
          break;
      }
    })
  }
  async getrout(){
    const data = await this.generateRoutes('console') // 动态增加路由
    this.$store.commit('permission/SET_ROUTES', data)
    this.$store.commit('permission/SET_APP_ROUTE_MAP', {
      appCode: 'console',
      appName: '控制中心',
      routes: data.length ? data[0].children : []
    })
    router.addRoutes(
      data.concat({
        path: '*',
        redirect: '/404'
      })
    )
    this.$router.push('/platform/product-main-data')
  }
  openQualityTesting(){
    popsp.processDetail(this.selectedKey).then(res =>{
      this.porcessItem =  res
      this.qualityTestingVisible = true
    })
    popwsrsp.getProcessMember(this.selectedKey).then(res => {
      this.qualityPerson = res
    })
  }
  closeQualityTesting(){
    this.qualityTestingVisible = false
    this.$emit('reloadWip')
  }

  render() {
    return (
      <div style="height: 100%">
        <div style="margin-bottom: 8px;">
          <a-button type="default" v-acl={'page_plan_wip_warehousing' + '_' + this.planTypeId} disabled={!this.currentWork || this.plan.category === 2} onClick={() => this.WIPwarehousing()}>{this.$t('page_plan_wip_warehousing')}</a-button>
          <a-button type="default" v-acl={'page_plan_wip_delivery' + '_' + this.planTypeId} disabled={!this.currentWork || this.plan.category === 2} onClick={() => this.WIPdelivery()}>{this.$t('page_plan_wip_delivery')}</a-button>
          <a-button type="default" v-acl={'page_job_plan_quality' + '_' + this.planTypeId}  disabled={!this.currentWork} onClick={() => this.qualityTesting()}>{this.$t('page_job_plan_quality')}</a-button>
        </div>
        <div style="height: calc(100% - 34px)">
          <ml-table
            size="small"
            bordered={true}
            columns={this.showColumns}
            dataSource={this.data}
            loading={this.loading}
            pagination={false}
            rowKey="id"
            style={{ marginBottom: '16px' }}
            canChangeColWidth={true}
            canFixedHead={true}
            selectRowKey={this.selectedKey}
            customRow={(record, index) => ({
              on: {
                click: () => {
                  this.clickRow(record, index)
                },
              },
            })}
            scroll={{ x: 1400, y: this.scrollY }}
          ></ml-table>
        </div>
        <wip-warehousing
          plan={this.plan}
          currentData={this.currentData}
          currentWork={this.currentWork}
          materialList={this.materialList}
          treeList={this.treeList}
          employeesList={this.employeesList}
          allAreaList={this.listWare}
          visible={this.WIPwarehousingVisible}
          onClose={() => this.WIPwarehousingVisible = false}
          onReload={() => this.reloadWip()}
        ></wip-warehousing>
        <wip-delivery
          plan={this.plan}
          currentData={this.currentData}
          currentWork={this.currentWork}
          materialList={this.materialList}
          treeList={this.treeList}
          employeesList={this.employeesList}
          allAreaList={this.listWare}
          visible={this.WIPdeliveryVisible}
          onClose={() => this.WIPdeliveryVisible = false}
          onReload={() => this.reloadWip()}
        ></wip-delivery>
        <quality-testing
          item={this.porcessItem}
          person={this.qualityPerson}
          visible={this.qualityTestingVisible}
          onCancel={() => this.qualityTestingVisible = false}
          onSave={() => this.closeQualityTesting()}
        >
        </quality-testing>
      </div>
    )
  }
}

@Component({
  components: {
    ScrapTable
  },
})
class StationTable extends Vue {
  @Prop({ default: () => {} }) readonly data
  @Prop({ default: false }) readonly loading: boolean
  @Prop({ default: () => [] }) readonly employeeData: EmployeeInfoBO[]
  @Prop() readonly processId: string
  @Prop({ default: false }) readonly reportOnly: boolean

  public numbers = []
  public employeeIds = []
  public yieldRatios = []
  public extraFieldVals = []

  public scrapList = {}
  scrapReasons = []
  scrapType = []
  personList = []
  // 轮询去拿已开工工位的最新的采集数量
  timer = null
  public extraFields = []

  @Watch('data',{immediate: true,deep: true})
  async getScrapList(){
    stsp.getPageScrappedReason(1,'',-1).then(res =>{
      this.scrapType = res.records
    })
  }
  created(): void {
    this.getExtraFields()
  }

  beforeDestroy(){
    clearTimeout(this.timer)
    this.timer = null
  }
  @Watch('numbers',{immediate: true})
  handle(val){
    this.$emit('numbers', val)
  }

  @Watch('data',{immediate: true})
  handleDate(val){
    if (val.orderProcessWorkStations && val.orderProcessWorkStations.length > 0) {
      this.timer = setInterval(() => {
        val.orderProcessWorkStations.forEach((res) => {
          console.log('orderProcessWorkStations:', res)
          if (res.workStationStatus === 2) {
            workStationWorkingConditionParamSettingServiceProxy.getPropertyLatestValue(res.workStationId).then(re => {
              // 实际值
              this.$set(res, 'collectTrueNum', (Number(re) - res.collectionNum) * res.yieldRatio)
              res.collectTrueNum = (Number(re) - res.collectionNum) * res.yieldRatio
            })
          }
        })
      }, 5000)
    }
    let aa = []
    val.orderProcessWorkStations.map(item =>{
      aa.push(
        Object.assign({}, item, {
          num: 0,
        })

      )
    })
    val.orderProcessWorkStations = aa
  }

  startOrReport(t: number, record, index) {
    if (t === 1) this.handleStart(record, index)
    if (t === 2) this.handleReport(record, index)
  }
  filterOption(input, option) {
    return (
      option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    );
  }
  changePerson(record) {
    if(this.data.processAssignMode == 1) {
      this.getEmployeeList(record.workStationId)
    }else{
      this.personList = this.employeeData
    }
  }

  async getEmployeeList(id) {
    let res = await productionOrderProcessAssignRecordServiceProxy.getOpenEmployee(this.data.orderProcessId,id)
    this.personList = res
  }

  // 获取用户自定义字段
  async getExtraFields() {
    this.extraFields = []
    let res = await fssp.listFieldSettings('page_plan_report_work_order')
    res.map(item=>{
      if(item.isDisplay) {
        this.extraFields.push({
          name: item.name,
          code: item.code,
          value: ''
        })
      }
    })
  }

  changePersonId(record,index) {
    this.getUnreportNum(record,index)
  }

  async getUnreportNum(record,index) {
    console.log(5555,this.employeeIds[index])
    if(this.employeeIds[index] != undefined) {
      let res = await productionOrderProcessAssignRecordServiceProxy.employeeUnReportNum(this.employeeIds[index],this.data.orderProcessId,record.workStationId)
      record.num = res
    }else(
      record.num = 0
    )
  }

  handleStart(record, index) {
    const id = this.employeeIds[index]
    if (!id) {
      this.$message.info(this.$t('page_plan_choose_operation_personal'))
      return
    }
    const body = {
      employeeId: this.employeeIds[index],
      employeeName: this.personList.find(item => item.id === id)?.name,
      employeeCode: this.personList.find(item => item.id === id)?.code,
      orderProcessId: this.processId,
      workStationId: record.workStationId,
      workStationName: record.workStationName,
      yieldRatio: this.yieldRatios[index]
    }

    this.$emit('start', [body])
  }

  handleReport(record, index) {
    const body = {
      qualifyNum: this.numbers[index].success,
      scrappedNum: this.numbers[index].fail,
      recordId: record.workStationRecordId,
      workStationScrappedRecordDTOList: this.scrapList[index]
    } as OrderProcessReportWorkDTO
    this.extraFields.map(item=>{
      body[item.code] = this.extraFieldVals[index][item.code]
    })
    this.$emit('report', [body])
  }

  changeData(value,index){
    this.scrapList[index] = value
  }

  // methods 正则替换小数点
  limitNumber(value) {
    if (typeof value === 'string') {
      return !isNaN(Number(value)) ? value.replace(/\./g, '') : 0
    } else if (typeof value === 'number') {
      return !isNaN(value) ? String(value).replace(/\./g, '') : 0
    } else {
      return 0
    }
  }

  render() {
    return (
      <div>
        {this.data.orderProcessWorkStations.map((record,index) =>{
          return (
            <div style="border:1px solid #e8e8e8;margin-bottom: 8px;">
              <div style="display: flex;align-content: center;justify-content: space-between;padding: 8px 4px;background-color:#e8e8e8">
                {record.workStationName}
                <div style={{display:record.assignNum===null?'none':'block'}}><span>{this.$t('page_plan_process_assigned_quantity')}：</span><span>{record.assignNum}</span></div>
                <div style={{display:record.unreportNum===null?'none':'block'}}><span>{this.$t('page_plan_processed_num')}：</span><span>{record.unreportNum}</span></div>
                <div style={{marginRight:'10px'}}><span>{this.$t('page_collection_quantity')}：</span><span>{record.workStationStatus == 1 ? '--' : (record.collectTrueNum ? record.collectTrueNum : 0)}</span>
                  <a-tooltip>
                    <template slot="title">
                      <span>{this.$t('page_work_order_tip2')}</span>
                    </template>
                    <a-icon type="question-circle" style="margin-left:40px"/>
                  </a-tooltip>
                </div>
                <div>
                  <a-button type="primary" size="small" onClick={() => this.startOrReport(record.workStationStatus, record, index)}>
                    {record.workStationStatus == 1 ? this.$t('page_plan_start_work') : this.$t('page_plan_report_work')}
                  </a-button>
                </div>
              </div>
              <div>
                <a-form-model label-col={{span: 5}} wrapper-col={{span: 14}}>
                  <a-row>
                    <a-col span={12}>
                      <a-form-model-item label={this.$t('page_plan_process_persoal')}>
                        {record.workStationStatus == 1 ?
                          <a-select show-search  filter-option={this.filterOption} placeholder={this.$t('page_plan_process_persoal')}
                          v-model={this.employeeIds[index]} allowClear style="width: 120px" onDropdownVisibleChange={()=>this.changePerson(record)} onChange={()=>this.changePersonId(record,index)}>
                            {this.personList.map(item => (
                              <a-select-option value={item.id}>{item.name}</a-select-option>
                            ))}
                          </a-select> :  record.producerName}
                      </a-form-model-item>
                    </a-col>
                    <a-col span={12}>
                      <a-form-model-item label={this.$t('page_plan_wait_report_num')} style={{display:this.data.processAssignMode!=0?'block':'none'}}>
                        { record.workStationStatus === 1 ? record.num:record.employeeUnreportNum  }
                      </a-form-model-item>
                    </a-col>
                    <a-col span={12}>
                      {/*产量倍率*/}
                      <a-form-model-item label={this.$t('page_plan_yield_ratio')}>
                        { record.workStationStatus === 1 ?
                          (!this.yieldRatios[index] ?  this.$set(this.yieldRatios, index, record.yieldRatio ? record.yieldRatio : 1) :
                            <a-input-number min={1} v-model={this.yieldRatios[index]} precision={0}
                          formatter={this.limitNumber} parser={this.limitNumber} style="width: 120px;"/>)
                          : record.yieldRatio}
                      </a-form-model-item>
                    </a-col>
                    <a-col span={12}>
                      <a-form-model-item label={this.$t('page_plan_qualified_number')}>
                        { record.workStationStatus === 1 ? '-' :
                          (!this.numbers[index] ? this.$set(this.numbers, index, { success: 0, fail: 0 }) :
                            <a-input-number min={0} v-model={this.numbers[index].success} /> ) }
                      </a-form-model-item>
                    </a-col>
                    <a-col span={12}>
                      <a-form-model-item label={this.$t('page_plan_scrap_number')}>
                        { record.workStationStatus === 1 ? '-' :
                          (!this.numbers[index] ? this.$set(this.numbers, index, { success: 0, fail: 0 }) :
                            <a-input-number min={0} v-model={this.numbers[index].fail} /> ) }
                      </a-form-model-item>
                    </a-col>

                    {this.extraFields.map((item, i, arr)=>{
                      let init = {}
                      arr.forEach(a=>{
                        init[item.code] = ''
                      })
                      if(record.workStationStatus === 1) {
                        return null
                      }
                      return (
                        <a-col span={12}>
                          <a-form-model-item label={item.name}>
                            { record.workStationStatus === 1 ? '-' :
                              (!this.extraFieldVals[index] ? this.$set(this.extraFieldVals, index, init) :
                                <a-input placeholder={this.$t('common_please_input')}
                                         v-model={this.extraFieldVals[index][item.code]} /> ) }
                          </a-form-model-item>
                        </a-col>
                      )
                    })}

                  </a-row>
                </a-form-model>
              </div>
              {record.workStationStatus === 2 ?
                <scrap-table
                  scrapType={this.scrapType}
                  scrapNumber={this.numbers[index].fail}
                  onChangeData={value => this.changeData(value,index)}
                ></scrap-table> : null
              }
            </div>
          )
        })}
      </div>
    )
  }
}

@Component({
  components: {
    WorkTable,
    ProcessTable,
    StationTable,
    DistributePlan,
    StationCapacity,
    ExportDropdown,
    RecordButton,
    PointModal
  },
})
export default class WorkOrder extends Vue {

  @Ref() workTable: WorkTable
  @Ref() processTable: ProcessTable
  @Ref() stationTable: StationTable
  @Ref() stationTable1: StationTable

  @Prop({ default: () => null }) readonly plan: ProductionPlan

  currentWork: ProductionOrderOutDTO = null
  currentProcess: OrderProcessOutDTO = null
  currentWorkIndex = 0
  currentProcessIndex = 0

  workData: ProductionOrderOutDTO[] = []
  processData: OrderProcessOutDTO[] = []

  loading = { workTable: false, processTable: false, print: true, startOrReport: true, finishOrder: false, report: false }
  visible = { print: false, startOrReport: false, report: false }

  cardData: CraftCardBO = null
  startOrReportData = null
  employeeData: EmployeeInfoBO[] = []
  distributeVisible = false
  stationCapacity = false
  resizeTimer = null
  workOrderScrollHeight = 120
  processScrollHeight = 120
  printVisible = false
  dataList = []
  numbers = []

  reportData = null
  startingJobData:any = {} // 开工中的工单信息
  backFromReport = false
  workSelectedKey = "" //workorder
  processSelectedKey = "" //process

  get canDelete() {
    return !!this.currentWork
  }

  get canPrint() {
    return !!this.currentWork
  }

  get canStartOrReport() {
    const statusList = {
      1: this.$t('page_plan_status_2'),
      2: this.$t('page_plan_status_3'),
      3: this.$t('page_plan_stop'),
      4: this.$t('page_plan_close'),
      5: this.$t('page_plan_finish'),
    }
    return (
      !!this.currentProcess &&
      ([1, 2].includes(this.currentProcess.processStatus) ||
        [statusList[1], statusList[2]].includes(this.currentProcess.processStatus.toString()))
    )
  }

  get canBatchStart() {
    if (!this.startOrReportData) return false
    return (
      this.startOrReportData?.orderProcessWorkStations?.length ===
      this.startOrReportData?.orderProcessWorkStations?.filter(item => item.workStationStatus === 1).length
    )
  }

  get canBatchReport() {
    if (!this.startOrReportData) return false
    return (
      this.startOrReportData?.orderProcessWorkStations?.length ===
      this.startOrReportData?.orderProcessWorkStations?.filter(item => item.workStationStatus === 2).length
    )
  }

  get canBatchReportOnly() {
    if(!this.reportData) return false
    return (
      this.reportData?.orderProcessWorkStations?.length ===
      this.reportData?.orderProcessWorkStations?.filter(item => item.workStationStatus === 2).length
    )
  }

  get dataId() {
    const arr = this.$route.fullPath.split('/')
    return arr[arr.length - 1]
  }

  get planTypeId() {
    const chars = this.$route.path.split('/')
    return chars[chars.length - 1]
  }

  // 控制是否可以完成工单
  get canFinishOrder() {
    return this.currentWork && this.plan?.planMode === 2
  }

  @Watch('plan', { immediate: true,deep : true })
  async loadWorkData(val: ProductionPlan) {
    if (Object.keys(val).length == 0 ) {
      this.workData = []
      this.processData = []
    }else {
      this.getWorkData()}
  }



  async getWorkData(){
    try {
      this.loading.workTable = true
      this.workData = await posp.orderLis(String(this.plan.id))
      if (this.workData.length > 0) {
        this.workData.forEach(res => {
          res.startTime = this.covertTime(res.startTime) as any
          res.endTime = this.covertTime(res.endTime) as any
        })
        if (!!this.workData[this.currentWorkIndex]) {
          this.workSelectedKey = this.workData[this.currentWorkIndex].id
          this.currentWork = this.workData[this.currentWorkIndex]
        } else {
          this.workSelectedKey = this.workData[0].id
          this.currentWorkIndex = 0
          this.currentWork = this.workData[0]
        }
      } else {
        this.currentProcess = null
        this.currentWork = null
      }
      this.loading.workTable = false
      this.processData = []
      this.startOrReportData = null
      this.reportData = null
      if (!this.backFromReport) {
        this.loading.startOrReport = true
      }
    } catch (e) {
      this.loading.workTable = false
    }
    this.ChangeColHeight()
  }

  @Watch('currentWork', { immediate: true, deep: true })
  async loadProcessData(val: ProductionOrderOutDTO) {
    if (!val) return
    try {
      this.loading.processTable = true
      this.processData = await posp.processList(val.id)
      this.processData.forEach(res => {
        res.standardTime = convertSeconds(res.standardTime) as any
      })
      if (!!this.processData[this.currentProcessIndex]) {
        this.processSelectedKey = this.processData[this.currentProcessIndex].id
        this.currentProcess = this.processData[this.currentProcessIndex]
      } else {
        this.processSelectedKey = this.processData[0].id
        this.currentProcessIndex = 0
      }
      this.loading.processTable = false
    } catch (e) {
      this.loading.processTable = false
    }
  }

  @Watch('workData', { deep: true })
  selectFirstProcess(val) {
    if (val?.length > 0) {
    }
  }
  reloadProcess(){
    this.loadProcessData(this.currentWork)
  }

  async deleteWorks() {
    try {
      this.loading.workTable = true
      await posp.deleteOrder([this.currentWork.id])
      // 去刷新生产计划列表
      this.getWorkData()
      this.workData = await posp.orderLis(String(this.plan.id))
      this.processData = []
      this.loading.workTable = false
    } catch (e) {
      this.loading.workTable = false
    }
  }

  async openPrint() {
    try {
      this.loading.print = true
      this.cardData = await posp.getCraftCard(this.currentWork.id)
      this.visible.print = true
      this.loading.print = false
    } catch (e) {
      this.visible.print = false
    }
  }

  download() {
    const element: HTMLElement = document.querySelector('#print-container') // 这个dom元素是要导出pdf的div容器
    const w = element.offsetWidth // 获得该容器的宽
    const h = element.offsetHeight // 获得该容器的高
    const offsetTop = element.offsetTop // 获得该容器到文档顶部的距离
    const offsetLeft = element.offsetLeft // 获得该容器到文档最左的距离
    const canvas = document.createElement('canvas')
    let abs = 0
    const win_i = document.documentElement.offsetWidth // 获得当前可视窗口的宽度（不包含滚动条）
    const win_o = window.innerWidth // 获得当前窗口的宽度（包含滚动条）
    if (win_o > win_i) {
      abs = (win_o - win_i) / 2 // 获得滚动条长度的一半
    }
    canvas.width = w * 2 // 将画布宽&&高放大两倍
    canvas.height = h * 2
    const context = canvas.getContext('2d')
    context.scale(2, 2)
    context.translate(-offsetLeft - abs, -offsetTop)
    // 这里默认横向没有滚动条的情况，因为offset.left(),有无滚动条的时候存在差值，因此
    // translate的时候，要把这个差值去掉
    html2canvas(element).then(canvas => {
      const contentWidth = canvas.width
      const contentHeight = canvas.height
      // 一页pdf显示html页面生成的canvas高度;
      const pageHeight = (contentWidth / 592.28) * 841.89
      // 未生成pdf的html页面高度
      let leftHeight = contentHeight
      // 页面偏移
      let position = 0
      // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
      const imgWidth = 595.28
      const imgHeight = (592.28 / contentWidth) * contentHeight
      const pageData = canvas.toDataURL('image/jpeg', 1.0)
      const pdf = new jspdf('', 'pt', 'a4')
      // 有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
      // 当内容未超过pdf一页显示的范围，无需分页
      if (leftHeight < pageHeight) {
        pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
      } else {
        // 分页
        while (leftHeight > 0) {
          pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
          leftHeight -= pageHeight
          position -= 841.89
          // 避免添加空白页
          if (leftHeight > 0) {
            pdf.addPage()
          }
        }
      }
      pdf.save(this.$t('page_plan_process_flow_card') + this.cardData.orderCode + '.pdf')
    })
  }

  async openStartOrReport() {
    this.loading.startOrReport = true
    this.visible.startOrReport = true
    const { data } = await popsp.getProcessDetail(this.currentProcess.id)
    this.startOrReportData = { ...data }
    const filterStatusList = {statusList: [1]} as any
    const { records } = await esp.getPageEmployees(1, filterStatusList, '', 9999)
    this.employeeData = records
    this.loading.startOrReport = false
  }
  async openReportOnly() {
    this.loading.report = true
    this.visible.report = true
    const { data } = await popsp.getProcessDetail(this.startingJobData.processId)
    this.reportData = { ...data }
    this.loading.report = false
  }

  closeStartOrReport(reportOnly?: boolean) {
    if (reportOnly) {
      this.visible.report = false
      this.loading.report = false
    } else {
      this.backFromReport = false
      this.visible.startOrReport = false
      this.loading.startOrReport = true
    }
  }

  async startWork(payload) {
    this.backFromReport = false
    try {
      const res = await popsp.startWork(payload)
      this.$message.success(`${res.msg}`)
      this.visible.startOrReport = false
      await this.refresh()
    } catch (e) {
      this.handleErr(e.response.data)
    }

  }

  handleErr(err) {
    // 已开工，转入报工
     if(err.code===519) {
       let msg = JSON.parse(err.msg)
       let ids = msg.detail.split(',')
       this.$confirm({
         content: msg.message,
         icon: 'exclamation-circle',
         okText: this.$t('page_report_to_work_immediately') as any,
         class: 'report-confirm',
         onOk: () => {
           // 当前工位正在被占用的开工信息
           let keys = ['workstationId', 'planId', 'jobId', 'processId']
           keys.map((k, i) => {
             this.startingJobData[k] = ids[i] ? ids[i] : ''
           })
           this.openReportOnly()
         }
       })
     }
  }

  async reportWork(payload, reportOnly?:boolean) {
    if (isNull(payload[0].qualifyNum) || isNull(payload[0].scrappedNum)) {
      this.$message.error(this.$t('page_plan_please_input_num'))
      return
    }
    console.log('报工数据：', payload)
    const res = await popsp.reportWork(payload)
    this.$message.success(`${this.$t('page_plan_report_work_success')}`)
    if (reportOnly) {
      this.visible.report = false
      this.backFromReport = true
    } else {
      this.visible.startOrReport = false
    }
    await this.refresh()
  }

  async handleBatchStart() {
    this.backFromReport = false
    let { employeeIds, employeeData, yieldRatios } = this.stationTable

    employeeIds = employeeIds.filter(res => res)
    if (employeeIds.length !== this.startOrReportData.orderProcessWorkStations.length) {
      this.$message.info(this.$t('page_plan_choose_process_persoal'))
      return
    }
    const body = employeeIds.map((eid, index) => {
      console.log(employeeData,eid)
      return {
        employeeId: eid,
        employeeName: employeeData.find(item => item.id === eid)?.name,
        employeeCode: employeeData.find(item => item.id === eid)?.code,
        orderProcessId: this.currentProcess.id,
        workStationId: this.startOrReportData.orderProcessWorkStations[index].workStationId,
        workStationName: this.startOrReportData.orderProcessWorkStations[index].workStationName,
        yieldRatio: yieldRatios[index]
      }
    }) as any
    try {
      const res = await popsp.startWork(body)
      this.$message.success(`${res.msg}`)
      this.visible.startOrReport = false
      await this.refresh()
    } catch (e) {
      this.handleErr(e.response.data)
    }

  }

  async handleBatchReport(reportOnly?:boolean) {
    const { numbers, scrapList, extraFieldVals, extraFields } = reportOnly ? this.stationTable1 : this.stationTable
    if (!reportOnly && numbers.length !== this.startOrReportData.orderProcessWorkStations.length) {
      this.$message.info(this.$t('page_plan_please_input_num'))
      return
    }
    if (reportOnly && numbers.length !== this.reportData.orderProcessWorkStations.length) {
      this.$message.info(this.$t('page_plan_please_input_num'))
      return
    }
    for (let i = 0; i < numbers.length; i++) {
      if (isNull(numbers[i].success) || isNull(numbers[i].fail)) {
        this.$message.error(this.$t('page_plan_please_input_num'))
        return
      }
    }

    const body = numbers.map((item, index) => {
      let fields = {
        recordId: reportOnly ? this.reportData.orderProcessWorkStations[index].workStationRecordId:this.startOrReportData.orderProcessWorkStations[index].workStationRecordId,
        qualifyNum: item.success,
        scrappedNum: item.fail,
        workStationScrappedRecordDTOList: scrapList[index]
      } as OrderProcessReportWorkDTO

      extraFields.forEach(field=>{
        fields[field.code] = extraFieldVals[index][field.code]
      })
      return fields
    })

    const res = await popsp.reportWork(body)
    this.$message.success(`${this.$t('page_plan_report_work_success')}`)
    if(reportOnly) {
      this.visible.report = false
      this.backFromReport = true
    } else {
      this.visible.startOrReport = false
    }

    await this.refresh()
  }

  async refresh() {
    if (!this.backFromReport) {
      this.loading.startOrReport = true
      this.getWorkData()
    }
  }

  changeWork({ index, data }) {
    this.currentWork = data
    this.workSelectedKey = data.id
    this.currentWorkIndex = index
  }

  changeProcess({ index, data }) {
    this.currentProcess = data
    this.processSelectedKey = data.id
    this.currentProcessIndex = index
  }

  openEditWorkstation() {
    this.distributeVisible = true
  }

  openStationCapacity() {
    this.stationCapacity = true
  }

  closeassign() {
    this.distributeVisible = false
    this.stationCapacity = false
    this.loadProcessData(this.currentWork)
  }

  ChangeColHeight() {
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer)
    }
    this.resizeTimer = setTimeout(() => {
      this.workOrderScrollHeight = document.getElementById('workTable-List').clientHeight - 58
      // const workOrderTableBody: any = document.querySelector('#workTable-List .ant-table-body')
      // if (workOrderTableBody) {
      //   workOrderTableBody.style.maxHeight = this.workOrderScrollHeight + 'px'
      // }
      this.processScrollHeight = document.getElementById('processTable-List').clientHeight - 120
      // const ProcessTableBody: any = document.querySelector('#processTable-List .ant-table-body')
      // if (ProcessTableBody) {
      //   ProcessTableBody.style.maxHeight = this.processScrollHeight + 'px'
      // }
    }, 100)
  }
  //转换时间
  covertTime(time) {
    if (time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss') || ''
    }
    return ''
  }

  // 完成工单
  async finishOrder() {
    this.loading.finishOrder = true
    try {
      await posp.completeMultiModeOrder(this.currentWork.id)
      this.$message.success(this.$t('page_resource_pool_success'))
      this.refresh()
    } finally {
      this.loading.finishOrder = false
    }
  }
  getList() {
    this.dataList = []
    this.workData.map((item, index) => {
        if(this.currentWorkIndex === index) {
          this.dataList.push({
            code: item.code,
          })
        }
    })
  }
  printing() {
    this.getList()
    this.printVisible = true
  }
  cancel() {
    this.printVisible = false
    this.currentWorkIndex = 0
  }
  handlerPrint() {
    this.printVisible = false
    this.currentWorkIndex = 0
  }
  changeNumber(num) {
   this.numbers = num
  }

  // 开工失败且提示正在开工时，加载一个新的报工窗口
  renderReportModal() {
    return (
      <a-modal
        title={this.$t('page_plan_report_work')}
        maskClosable={false}
        v-model={this.visible.report}
        footer={() => (
          <div>
            <a-button onClick={() => this.closeStartOrReport(true)}>{this.$t('cancel')}</a-button>
            {this.canBatchReportOnly ? (
              <a-button type="primary" onClick={() => this.handleBatchReport(true)}>
                {this.$t('page_plan_batch_report')}
              </a-button>
            ) : (
              <a-button type="primary" disabled>
                {this.$t('page_plan_batch_report')}
              </a-button>
            )}
          </div>
        )}
        destroyOnClose={true}
        width={1024}
      >
        {this.loading.report ? (
          <div style="text-align: center; padding: 100px 0">
            <a-spin />
          </div>
        ) : (
          <div>
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px">
              <div style="width: 33%">
                {this.$t('page_product_process_name')}：{this.reportData?.orderProcessName}
              </div>
              <div style="width: 33%">
                {this.$t('page_plan_has_report_num')}：{this.reportData?.orderProcessReportNum}
              </div>
              <div style="width: 33%">
                {this.$t('page_plan_wait_report_num')}：{this.reportData?.orderProcessUnreportNum}
              </div>
            </div>
            <StationTable
              ref="stationTable1"
              loading={this.loading.report}
              data={this.reportData}
              employeeData={this.employeeData}
              processId={this.startingJobData?.processId}
              onReport={(body)=>this.reportWork(body, true)}
              reportOnly={true}
            />
          </div>
        )}
      </a-modal>
    )
  }

  render() {
    return (
      <div class="workOrder" style="overflow: hidden; height:100%">
        <div style="padding: 8px">
          {this.canPrint ? (
            <a-button v-acl={'page_production_plan_order_craft_card' + '_' + this.planTypeId} onClick={this.openPrint}>
              {this.$t('page_plan_process_flow_card')}
            </a-button>
          ) : (
            <a-button v-acl={'page_production_plan_order_craft_card' + '_' + this.planTypeId} disabled>
              {this.$t('page_plan_process_flow_card')}
            </a-button>
          )}
          {this.canDelete ? (
            <a-popconfirm
              title={this.$t('page_resource_pool_confirm_delete')}
              onConfirm={this.deleteWorks}
              okText={this.$t('yes')}
              cancelText={this.$t('no')}
            >
              <a-button type="danger" v-acl={'page_production_plan_order_delete' + '_' + this.planTypeId}>
                {this.$t('delete')}
              </a-button>
            </a-popconfirm>
          ) : (
            <a-button type="danger" v-acl={'page_production_plan_order_delete' + '_' + this.planTypeId} disabled>
              {this.$t('delete')}
            </a-button>
          )}
          {this.canStartOrReport ? (
            <a-button
              onClick={this.openStartOrReport}
              v-acl={'page_production_plan_order_start_report' + '_' + this.planTypeId}
            >
              {this.$t('page_plan_start_or_report_work')}
            </a-button>
          ) : (
            <a-button disabled v-acl={'page_production_plan_order_start_report' + '_' + this.planTypeId}>
              {this.$t('page_plan_start_or_report_work')}
            </a-button>
          )}
          <export-dropdown
            simple
            filename={`${this.$t('page_work_order')}.xlsx`}
            disabled={!this.canDelete}
            fn={exportWorkOrder.bind(this, this.plan?.id, { bizCode: 'plan_order', bizDataId: this.dataId })}
          >
            {this.$t('page_export_order')}
          </export-dropdown>
          <a-button
            disabled={!this.canStartOrReport}
            onClick={this.openEditWorkstation}
            v-acl={'page_production_plan_edit_workstation_' + this.planTypeId}
          >
            {this.$t('page_production_plan_edit_workstation')}
          </a-button>

           {/* 工位产能设置 */}
           <a-button
            disabled={!this.canStartOrReport}
            onClick={this.openStationCapacity}
            v-acl={'page_station_capacity_setting_' + this.planTypeId}
          >
            {this.$t('page_station_capacity_setting')}
          </a-button>


          <record-button
            v-acl={'page_work_report_history_' + this.planTypeId}
            disabled={!this.canDelete}
            orderId={this.currentWork?.id}
            onRefresh={this.refresh}
          ></record-button>
          {/* 完成工单 */}
          {!this.canFinishOrder ? (
            <a-button
              v-acl={'page_work_finish_report_' + this.planTypeId}
              disabled={!this.canFinishOrder}
              loading={this.loading.finishOrder}
              // onClick={this.finishOrder}
            >
              {this.$t('page_production_plan_finish_order')}
            </a-button>
          ) : (
            <a-popconfirm
              title={this.$t('page_production_plan_sure')}
              ok-text={this.$t('yes')}
              cancel-text={this.$t('no')}
              onConfirm={this.finishOrder}
            >
              <a-button
                v-acl={'page_work_finish_report_' + this.planTypeId}
                disabled={!this.canFinishOrder}
                loading={this.loading.finishOrder}
                // onClick={this.finishOrder}
              >
                {this.$t('page_production_plan_finish_order')}
              </a-button>
            </a-popconfirm>
          )}
           <a-button
          style={{ marginLeft: "8px" }}
          disabled={this.workData.length < 1}
          onClick={this.printing}
          >
            {this.$t('page_print_code')}
          </a-button>
        </div>
        <div id="workOrderTable" style="display:flex; flex-direction: column; height: calc(100% - 48px)">
          <div id="workTable-List" style="height: 50%; overflow: auto; padding: 0 8px;">
            <WorkTable
              ref="workTable"
              loading={this.loading.workTable}
              data={this.workData}
              currentData={this.currentWork}
              currentIndex={this.currentWorkIndex}
              selectedKey={this.workSelectedKey}
              scrollY={this.workOrderScrollHeight}
              onChange={this.changeWork}
              // style="height: 50%;"
            />
          </div>
          <div v-resize={{ axis: 'y', cb: this.ChangeColHeight }} style="background: #f8f8f8"></div>
          <div id="processTable-List" style="height: 50%; overflow: auto; padding: 8px">
            <ProcessTable
              ref="processTable"
              plan={this.plan}
              currentWork={this.currentWork}
              loading={this.loading.processTable}
              data={this.processData}
              currentData={this.currentProcess}
              selectedKey={this.processSelectedKey}
              currentIndex={this.currentProcessIndex}
              onChange={this.changeProcess}
              scrollY={this.processScrollHeight}
              onReloadWip={() => this.reloadProcess()}
              // style="height: 50%;"
            />
          </div>
          <point-modal
            visible={this.visible.print}
            loading={this.loading.print}
            cardData={this.cardData}
            onDownload={() => this.download()}
            onCancel={() => (this.visible.print = false)}>
          </point-modal>
          <a-modal
            title={this.$t('page_plan_start_or_report_work')}
            maskClosable={false}
            v-model={this.visible.startOrReport}
            footer={() => (
              <div>
                <a-button onClick={()=>this.closeStartOrReport()}>{this.$t('cancel')}</a-button>
                {this.canBatchStart ? (
                  <a-button v-acl={'page_plan_batch_start' + '_' + this.planTypeId} type="primary" onClick={this.handleBatchStart}>
                    {this.$t('page_plan_batch_start')}
                  </a-button>
                ) : (
                  <a-button v-acl={'page_plan_batch_start' + '_' + this.planTypeId} type="primary" disabled>
                    {this.$t('page_plan_batch_start')}
                  </a-button>
                )}
                {this.canBatchReport ? (
                  <a-button v-acl={'page_plan_batch_report' + '_' + this.planTypeId} type="primary" onClick={()=>this.handleBatchReport()}>
                    {this.$t('page_plan_batch_report')}
                  </a-button>
                ) : (
                  <a-button v-acl={'page_plan_batch_report' + '_' + this.planTypeId} type="primary" disabled>
                    {this.$t('page_plan_batch_report')}
                  </a-button>
                )}
              </div>
            )}
            destroyOnClose={true}
            width={1024}
          >
            {this.loading.startOrReport ? (
              <div style="text-align: center; padding: 100px 0">
                <a-spin />
              </div>
            ) : (
              <div>
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px">
                  <div style="width: 33%">
                    {this.$t('page_product_process_name')}：{this.startOrReportData.orderProcessName}
                  </div>
                  <div style="width: 33%">
                    {this.$t('page_collection_quantity')}：{this.startOrReportData.collectionNum}
                  </div>
                </div>
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px">
                <div style="width: 33%">
                    {this.$t('page_plan_order_no')}：{this.startOrReportData.orderCode}
                  </div>
                  <div style="width: 33%">
                    {this.$t('page_product_name')}：{this.startOrReportData.productName}
                  </div>
                </div>
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px">
                <div style="width: 33%">
                    {this.$t('page_plan_has_report_num')}：{this.startOrReportData.orderProcessReportNum}
                  </div>
                  <div style="width: 33%">
                    {this.$t('page_plan_wait_report_num')}：{this.startOrReportData.orderProcessUnreportNum}
                  </div>
                </div>
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px">
                  <div style="width: 33%">
                    {this.$t('page_plan_current_qualified_number')}：
                    {this.numbers.reduce((prev, curr) => prev + curr.success, 0)}
                  </div>
                  <div style="width: 33%">
                    {this.$t('page_plan_current_scrap_number')}：{this.numbers.reduce((prev, curr) => prev + curr.fail, 0)}
                  </div>
                </div>

                <div class='word_warning_show'><a-icon type="info-circle" theme='filled' style='color:rgb(74,144,226); margin-right: 5px;'/>{this.$t('page_work_order_tip')}</div>

                <StationTable
                  ref="stationTable"
                  loading={this.loading.startOrReport}
                  data={this.startOrReportData}
                  employeeData={this.employeeData}
                  processId={this.currentProcess.id}
                  onStart={this.startWork}
                  onReport={this.reportWork}
                  onNumbers={this.changeNumber}
                />
              </div>
            )}
          </a-modal>
          {this.renderReportModal()}
          {this.distributeVisible ? (
            <distribute-plan edit={true} onClose={this.closeassign} selectRows={this.currentWork}></distribute-plan>
          ) : null}

          {this.stationCapacity ? (
            <station-capacity edit={true} onClose={this.closeassign} selectRows={this.currentWork}></station-capacity>
          ) : null}


          {<code-model
            visible={this.printVisible}
            onCancel={this.cancel}
            dataList={this.dataList}
            onprint={this.handlerPrint}
            >
            </code-model>}
        </div>
      </div>
    )
  }
}
